module.exports = "<p>\r\n  estadisticas works!\r\n</p>\r\n"